<div class="flex flex-col items-center space-y-8 max-w-md mx-auto">
  <div class="w-full">
    <label class="block text-title-default text-xs mb-2">
      Enter code<span class="text-red-500">*</span>
    </label>
    <form [formGroup]="verificationForm" (ngSubmit)="verifyCode()" novalidate>
      <div class="flex gap-1 w-full justify-between" formArrayName="code">
        <ng-container *ngFor="let control of codeArray().controls; let i = index">
          <div class="relative w-full">
            <input
              #codeInput
              type="text"
              [formControlName]="i"
              maxlength="1"
              inputmode="numeric"
              (input)="onCodeInput(i, $event)"
              (keydown)="onKeyDown(i, $event)"
              (paste)="i === 0 && onPaste($event)"
              class="w-50x h-56x rounded-t-md border border-solid	bg-white text-center text-8gpx font-medium otp-text-input"
              [ngClass]="{
                'border-bottom-color-focus': ((codeInput.matches(':focus') || control.value) && !isInvalidOTP),
                'border-bottom-color-default': (!codeInput.matches(':focus') && !control.value && !isInvalidOTP),
                'border-bottom-color-error': isInvalidOTP && !isDisableState
              }"
              [attr.aria-label]="'Digit ' + (i + 1)"
            >
          </div>
        </ng-container>
      </div>
    <div class="flex justify-between mb-5">
      <div>
         <p class="text-danger-500 text-6gpx" *ngIf="isInvalidOTP && !isDisableState">Invalid OTP</p>
         <p class="text-success-500 text-6gpx" *ngIf="isOtpSent">OTP resent successfully</p>
      </div>
      <div>
        <button
        type="button"
        (click)="resendCode()"
        [disabled]="isCountdownActive"
        class="text-6gpx"
        [ngClass]="{
          'text-title-default cursor-default': isCountdownActive,
          'text-primary-400 hover:text-primary-400': !isCountdownActive
        }"
      >
        {{ isCountdownActive ? 'Resend code in ' + countdown + 's' : 'Resend code' }}
      </button>
      </div>
    </div>
    <div class="flex items-center justify-center">
  <button
  [disabled]="(!isCodeComplete() || isDisableState)"
  type="submit"
  class="h-12 w-full md:w-auto px-6 py-3 items-center justify-center text-white flex w-full text-7gpx font-body-semibold rounded-gt-md-3"
  [ngClass]="{
    'bg-secondary-300 cursor-not-allowed': (!isCodeComplete() || isDisableState),
    'bg-primary-400 focus:bg-primary-400': isCodeComplete() && !isDisableState
  }">
  Verify
</button>
</div>
</form>
</div>
</div>